import { InvoiceDateFieldDescriptor } from "../InvoiceDateFieldEditor";
import { FieldType } from "@crispico/foundation-react/entity_crud/FieldType";
import { TabRouterPane } from "@crispico/foundation-react/components/TabbedPage/TabbedPage";
import { EntityDescriptor, EntityEditorPage, EntityEditorPageProps, Utils } from "@crispico/foundation-react";

export class InvoiceRuleEntityDescriptor extends EntityDescriptor {
    constructor() {
        super({
            name: "InvoiceRule",
            icon: "file text"
        });
    }

    protected customize() {
        this.addFieldDescriptor({ name: "daysOfTheWeek", type: FieldType.daysOfTheWeek, startingDay: 2 });
        this.addFieldDescriptor({ name: "details", type: FieldType.text });
        this.addFieldDescriptor({ name: "flightType", type: FieldType.dropdown , fieldDescriptorSettings: {
            fieldIntervals: [
                { from: "S", label: _msg("FlightAndObjectAction.flightType.short.label") },
                { from: "M", label: _msg("FlightAndObjectAction.flightType.medium.label") },
                { from: "L", label: _msg("FlightAndObjectAction.flightType.long.label") }]
             }
        });
        this.addFieldDescriptor({ name: "departure", type: FieldType.dropdown, fieldDescriptorSettings: {
                fieldIntervals: [
                    { from: "0", label: _msg("InvoiceRule.departure.ignore") },
                    { from: "1", label: _msg("InvoiceRule.departure.yes") },
                    { from: "2", label: _msg("InvoiceRule.departure.no") }]
            }
        });
        this.addFieldDescriptor({ name: "payType", type: FieldType.dropdown, fieldDescriptorSettings: {
                fieldIntervals: [
                    { from: "CONTRACT", label: _msg("invoiceAccount.payType.contract") },
                    { from: "BANK_CARD", label: _msg("invoiceAccount.payType.bankCard") },
                    { from: "OIL_CARD", label: _msg("invoiceAccount.payType.oilCard") }]
            }
        });
        this.addFieldDescriptor({ name: "startTime", additionalFieldEditorProps: { isStartOfDay: true }, additionalFieldRendererProps: { format: Utils.dateFormat } }, new InvoiceDateFieldDescriptor());
        this.addFieldDescriptor({ name: "endTime", additionalFieldRendererProps: { format: Utils.dateFormat } }, new InvoiceDateFieldDescriptor());
        this.isInDefaultColumnConfig(true, "id", "airline", "number", "daysOfTheWeek", "origin", "destination", "departure", "startTime", "endTime", "flightType", "priority", "tva", "tic", "clientLivre", "nightInterval", "details", "contractNumber", "payType", "planeType");

       	this.infoEditor.wrappedComponentClass = class extends EntityEditorPage<EntityEditorPageProps> {
            protected getExtraTabPanes(): (TabRouterPane | null)[] {
                return [
                    ...super.getExtraTabPanes(),
                    this.createOneToManyTabPane("InvoicePriceRule", "invoiceRule")
                ];
            }
        }
    }
}